import { Card } from '../../../components/ui/card';
import { ChefHat, Scroll, TrendingUp, Calculator } from 'lucide-react';

interface RecipeQuickStatsProps {
  stats: {
    totalRecipes: number;
    customRecipes: number;
    scaledToday: number;
    avgScaleFactor: number;
  };
}

/**
 * Recipe Quick Stats Component
 * 
 * Displays a dashboard of key recipe manager metrics:
 * - Total recipes in collection
 * - Custom recipes created
 * - Recipes scaled today
 * - Average scaling factor
 */
export function RecipeQuickStats({ stats }: RecipeQuickStatsProps) {
  const statCards = [
    {
      label: 'Total Recipes',
      value: stats.totalRecipes,
      icon: Scroll,
      color: 'text-coral',
      bgColor: 'bg-coral/10',
    },
    {
      label: 'Custom Recipes',
      value: stats.customRecipes,
      icon: ChefHat,
      color: 'text-sage',
      bgColor: 'bg-sage/10',
    },
    {
      label: 'Scaled Today',
      value: stats.scaledToday,
      icon: Calculator,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      label: 'Avg Scale',
      value: `${stats.avgScaleFactor.toFixed(1)}x`,
      icon: TrendingUp,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statCards.map((stat, idx) => (
        <Card key={idx} className="p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {stat.label}
              </p>
              <p className="text-3xl font-bold text-martinique">
                {stat.value}
              </p>
            </div>
            <div className={`p-3 rounded-full ${stat.bgColor}`}>
              <stat.icon className={`h-6 w-6 ${stat.color}`} />
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
